<template>
	<div>
		<h1>Mandanten</h1>
		<button @click="editFrm(0)"><i class="fas fa-plus"></i> Hinzufügen</button> <input type="text" v-model="search_txt" placeholder="Suche..." @keyup.enter="search" class="left_space">
		<table>
			<thead>
				<th>Name</th>
				<th>Suchbegriff</th>
				<th>MWST-Pflicht</th>
				<th>Debi/Kredi</th>
				<th>Fibu-Software</th>
				<th></th>
				<th></th>
				<th></th>
			</thead>
			<tbody>
				<tr v-for="(rec,idx) in recs" :key="idx">
					<td>{{ rec.name }}</td>
					<td>{{ rec.searchterm }}</td>
					<td><span class="badge" :class="rec.vat_method === 'NOT_TAXABLE' ? 'locked' : rec.vat_method">{{ vat_label(rec.vat_method) }}</span></td>
					<td><span class="badge" :class="rec.accounts_receivable_payable === '1' ? 'active' : 'locked'">{{ rec.accounts_receivable_payable === '1' ? 'JA' : 'NEIN' }}</span></td>
					<td>{{ rec.accounting_tool }}</td>
					<td><i class="fas fa-cog" @click="showClientParam(rec.id)"></i></td>
					<td><i class="fas fa-pencil-alt" @click="editFrm(rec.id)"></i></td>
					<td><i class="fas fa-trash-alt" @click="deleteConfirm(rec.id)"></i></td>
				</tr>
			</tbody>
		</table>
		
		<modal name="modalDel" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Löschung bestätigen</div>
			<div class="delConf-content">
				Mandant '{{ delClientName }}' wirklich löschen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="deleteRec" class="delConf-btn-del">Löschen</button>
				<button @click="$modal.hide('modalDel')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalEdit" width="500" height="auto" :clickToClose="false" draggable=".delConf-title" @opened="$refs.uuz_name.focus()">
			<div class="delConf-title">Mandant bearbeiten</div>
			<div class="delConf-content">
				<label for="uuz_name">Name</label><input type="text" id="uuz_name" ref="uuz_name" v-model="edit.name"><br>
				<label for="uuz_searchterm">Suchbegriff</label><input type="text" id="uuz_searchterm" v-model="edit.searchterm"><br>
				<label for="uuz_vat_method">MWST-Pflicht</label><select id="uuz_vat_method" v-model="edit.vat_method">
					<option value="NOT_TAXABLE">Nicht pflichtig</option>
					<option value="EFFECTIVE">Effektiv</option>
					<option value="NET_TAX_RATE">Saldosteuersatz</option>
				</select><br>
				<label for="uuz_accounts_receivable_payable">Debi/Kredi</label><input type="checkbox" id="uuz_accounts_receivable_payable" v-model="edit.accounts_receivable_payable"><br>

				<fieldset v-show="edit.accounts_receivable_payable">
					<legend>Buchungstext-Vorlagen <i class="fas fa-question-circle" :title="posting_txt_hint"></i></legend>
					<label for="uuz_posting_txt_ar">Debitorenrechnungen</label><input type="text" id="uuz_posting_txt_ar" v-model="edit.posting_txt_ar"><br>
					<label for="uuz_posting_txt_ap">Kreditorenrechnungen</label><input type="text" id="uuz_posting_txt_ap" v-model="edit.posting_txt_ap"><br>
				</fieldset>

				<label for="uuz_accounting_tool">Fibu-Software</label><select id="uuz_accounting_tool" v-model="edit.accounting_tool">
					<option value="pesaris">Pesaris</option>
				</select><br>
				<label for="uuz_accounting_tool_version">Softwareversion</label><select id="uuz_accounting_tool_version" v-model="edit.accounting_tool_version">
					<option value="1">1</option>
					<option value="2">2</option>
				</select><br>
				<label for="uuz_accounting_tool_clientname">Loginname Mandant</label><input type="text" id="uuz_accounting_tool_clientname" v-model="edit.accounting_tool_clientname"><br>
				<span v-show="edit.accounting_tool === 'pesaris' && edit.accounting_tool_version === '2'">
					<label for="uuz_accounting_tool_uid">Benutzername</label><input type="text" id="uuz_accounting_tool_uid" v-model="edit.accounting_tool_uid"><br>
					<label for="uuz_accounting_tool_pwd">Passwort</label><input type="text" id="uuz_accounting_tool_pwd" v-model="edit.accounting_tool_pwd"><br>
				</span>
			</div>
			<div class="delConf-button-wrapper">
				<button @click="saveRec">Speichern</button>
				<button @click="$modal.hide('modalEdit')">Abbrechen</button>
			</div>
		</modal>
		<vue-snotify></vue-snotify>
	</div>
</template>

<script>
/*
CREATE TABLE `client` (
  `id` smallint(5) UNSIGNED NOT NULL,
  `name` varchar(255) NOT NULL,
  `searchterm` varchar(25) NOT NULL,
  `vat_method` enum('NOT_TAXABLE','EFFECTIVE','NET_TAX_RATE') NOT NULL,
  `accounts_receivable_payable` tinyint(1) NOT NULL,
  `accounting_tool` varchar(25) NOT NULL,
  `accounting_tool_version` smallint(6) NOT NULL,
  `accounting_tool_clientname` varchar(25) NOT NULL,
  `accounting_tool_uid` varchar(25) NOT NULL,
  `accounting_tool_pwd` varchar(25) NOT NULL,
  `deleted` date DEFAULT NULL,
  `deleted_by` smallint(5) UNSIGNED DEFAULT NULL
) ENGINE=InnoDB DEFAULT CHARSET=utf8;
*/
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'

  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			id: 0,
			delClientName: '',
			search_txt: '',
			edit: {
				name: '',
				searchterm: '',
				vat_method: 'NOT_TAXABLE',
				accounts_receivable_payable: false,
				posting_txt_ar: '',
				posting_txt_ap: '',
				accounting_tool: 'pesaris',
				accounting_tool_version: '2',
				accounting_tool_clientname: '',
				accounting_tool_uid: '',
				accounting_tool_pwd: ''
			},
			recs: [],
			posting_txt_hint: 'Personenkonto: {{firma_name}} / Bezeichnung: {{re_name}} / Rechnungsnummer: {{re_nr}} / Rechnungsdatum: {{re_datum}}'
		}
	},
    methods: {
      vat_label: function (val) {
		  switch(val) {
			  case 'NOT_TAXABLE': return 'KEINE'
			  case 'EFFECTIVE': return 'EFFEKTIV'
			  case 'NET_TAX_RATE': return 'SALDO'
		  }
		  return '???'
      },
      deleteConfirm: function (id) {
		var vm = this
		vm.id = parseInt(id)
		
		vm.delClientName = 'unknown'
        vm.$_.forEach(vm.recs, function (value) {
			if (value.id == id) {
				vm.delClientName = value.name
				return false
			}
	    })
		
        vm.$modal.show('modalDel')
      },
      deleteRec: function () {
		this.$modal.hide('modalDel')
		this.apiCall([{method: 'client/delete', param: {id: this.id}, id: 10},{method: 'client/list', param: {}, if: [{id: 10, path: 'result/success', eq: true}], id: 5}], this.evalApiResponse)
      },
      search: function () {
		this.apiCall([{method: 'client/list', param: {quicksearch: this.search_txt}, id: 5}], this.evalApiResponse)
      },
      saveRec: function () {
		var param = this.edit
		param['id'] = this.id
		param.accounts_receivable_payable = param.accounts_receivable_payable ? 1 : 0
		
		if (!param.accounts_receivable_payable) {
			param.posting_txt_ar = '';
			param.posting_txt_ap = '';
		}
		
		if (param.accounting_tool !== 'pesaris' && param.accounting_tool_version !== '2') {
			param.accounting_tool_uid = param.accounting_tool_pwd = ''
		}

		this.apiCall([{method: 'client/save', param: param, id: 15},{method: 'client/list', param: {}, if: [{id: 15, path: 'result/success', eq: true}], id: 5}], this.evalApiResponse)
      },
      editFrm: function (id) {
		this.id = parseInt(id)
		if (this.id === 0) {
			this.edit = {
				name: '',
				searchterm: '',
				vat_method: 'NOT_TAXABLE',
				accounts_receivable_payable: false,
				posting_txt_ar: '',
				posting_txt_ap: '',
				accounting_tool: 'pesaris',
				accounting_tool_version: '2',
				accounting_tool_clientname: '',
				accounting_tool_uid: '',
				accounting_tool_pwd: ''
			}
			this.$modal.show('modalEdit')
		} else {
			this.apiCall([{method: 'client/load', param: {"id": this.id}, id: 7}], this.evalApiResponse)
		}
      },
      showClientParam: function (id) {
        this.$router.push({ path: '/home/configuration/client/param/' + id})
      },
      evalApiResponse: function (resp) {
        var vm = this
        this.$_.forEach(resp, function (value) {
          if (value.hasOwnProperty('id')) {
            switch (value.id) {
              case 5: // 5 = Result from '.../list'
				vm.recs = value.result
                break
              case 7: // 7 = Result from '.../load'
                if (value.hasOwnProperty('error')) {
                } else {
                  if (value.hasOwnProperty('result') && value.result.hasOwnProperty('name')) {
                    vm.edit.name = value.result.name
                    vm.edit.searchterm = value.result.searchterm
                    vm.edit.vat_method = value.result.vat_method
                    vm.edit.accounts_receivable_payable = parseInt(value.result.accounts_receivable_payable) === 1
                    vm.edit.posting_txt_ar = value.result.posting_txt_ar;
                    vm.edit.posting_txt_ap = value.result.posting_txt_ap;
                    vm.edit.accounting_tool = value.result.accounting_tool
                    vm.edit.accounting_tool_version = value.result.accounting_tool_version
                    vm.edit.accounting_tool_clientname = value.result.accounting_tool_clientname
                    vm.edit.accounting_tool_uid = value.result.accounting_tool_uid
                    vm.edit.accounting_tool_pwd = value.result.accounting_tool_pwd
					vm.$modal.show('modalEdit')
                  }
                }
                break
              case 10: // 10 = Result from '.../delete'
                if (value.hasOwnProperty('error')) {
					vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
				}
                break
              case 15: // 15 = Result from '.../save'
                if (value.hasOwnProperty('error')) {
					vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
                } else {
					vm.$modal.hide('modalEdit')
					vm.$snotify.success('Mandantendaten gespeichert', 'OK')
				}
                break
            }
          }
        })
      }
    },
    mounted: function () {
//		console.log('greetings from mounted')
		this.apiCall([{method: 'client/list', param: {}, id: 5}], this.evalApiResponse)
    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

table {
	border-collapse: collapse;
	border: 1px solid #888;
}

th {
	background: #317dff;
	color: #fff;
	padding: 10px 10px;
	min-width: 30px;
	text-align: left;
	border-bottom: 1px solid #888;
}

td {
	color: #333;
	padding: 10px 10px;
	text-align: left;
}

td:nth-child(1) {min-width: 300px}
td:nth-child(3) {text-align: center}
td:nth-child(4) {text-align: center}

th:nth-child(3) {text-align: center}
th:nth-child(4) {text-align: center}

tr:nth-child(even) {background: #eee}
tr:nth-child(odd) {background: #fff}

td > i {
	cursor: pointer;
}

.badge {
	border-radius: 5px;
	padding: 3px 5px;
	color: #fff;
}

.badge.active {
	background: #080;
}

.badge.locked {
	background: #c00;
}

.badge.EFFECTIVE {
	background: #f38000;
}

.badge.NET_TAX_RATE {
	background: #bf22d7;
}

/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

/*EDIT DIALOG*/
.delConf-content label {
	display: inline-block;
	width: 200px;
}

.delConf-content input[type=text], .delConf-content select {
	width: 250px;
	border: 1px solid #888;
	margin-bottom: 5px;
	padding:3px;
	background: #fff;
}

.delConf-content fieldset > label {
	width: 185px;
}

.delConf-content fieldset {
	margin-bottom: 5px;
}

hr {
    border: none;
    height: 1px;
    color: #333; /* old IE */
    background-color: #333; /* Modern Browsers */
}

.left_space {
	margin-left: 30px;
}
</style>
